import * as React from 'react';

class ServiceWorkerContainer extends React.PureComponent {
  componentDidMount() {
    if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
      window.addEventListener('load', () => {
        if (!navigator.serviceWorker.controller) {
          // The window client isn't currently controlled so it's a new service
          // worker that will activate immediately
          return;
        }

        navigator.serviceWorker.getRegistrations().then(registrations => {
          for (const registration of registrations) {
            registration.unregister();
          }
        });
      });
    }
  }

  render() {
    return null;
  }
}

export default ServiceWorkerContainer;



// WEBPACK FOOTER //
// /www/client/src/containers/ServiceWorker/ServiceWorker.tsx